import React from 'react';
import { Container, Button, Card } from 'react-bootstrap';
import { FaExclamationCircle, FaRedo, FaHome } from 'react-icons/fa';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console (in production, send to error tracking service)
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container className="py-5" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Card className="text-center border-0 shadow-sm" style={{ maxWidth: '500px' }}>
            <Card.Body className="p-5">
              <FaExclamationCircle size={60} className="text-danger mb-4" />
              <h2 className="mb-3">Oops! Something went wrong</h2>
              <p className="text-muted mb-4">
                We're sorry, but something unexpected happened. 
                Please try refreshing the page or go back to the homepage.
              </p>
              
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <Card className="bg-light mb-4 text-start">
                  <Card.Body>
                    <small className="text-danger">
                      <strong>Error:</strong> {this.state.error.toString()}
                    </small>
                  </Card.Body>
                </Card>
              )}
              
              <div className="d-flex justify-content-center gap-3">
                <Button variant="primary" onClick={this.handleReload}>
                  <FaRedo className="me-2" /> Refresh Page
                </Button>
                <Button variant="outline-primary" onClick={this.handleGoHome}>
                  <FaHome className="me-2" /> Go Home
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
